// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-5cbbeedc] {\n  display: flex;\n  justify-content: center;\n}\n.content img[data-v-5cbbeedc] {\n  height: 400px;\n  width: auto;\n  margin-right: 100px;\n}\n.content h1[data-v-5cbbeedc] {\n  color: #5895ff;\n  font-weight: 500;\n  font-size: 120px;\n  margin: 0;\n}\n.content p[data-v-5cbbeedc] {\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 1.6rem;\n}\n", ""]);
// Exports
module.exports = exports;
